import { chatHistoryBGColor, chatInputDropShadow, grayText } from 'globals/colors';

import { awayImage, iconCollapse } from 'globals/assets';

const styles = {
  container: {
    flex: '1 1 auto',
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: chatHistoryBGColor,
    overflowY: 'scroll',
  },
  articleContainer: {
    position: 'absolute',
    height: '100%',
    width: '100%',
    top: 0,
    overflow: 'scroll',
    transition: 'all .2s linear',
    backgroundColor: 'white',
    marginTop: '10px',
  },
  articleContainerClosed: {
    top: '100%',
    height: 0,
  },
  scrollContainer: {
    flex: '1 1 auto',
    overflowY: 'auto',
    overflowX: 'hidden',
    position: 'relative',
  },
  iconContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    height: '35px',
    zIndex: 1,
    position: 'absolute',
    top: 0,
    background: '#fff',
    paddingRight: '14px',
    paddinTop: '15px',
    width: '100%',
    alignItems: 'center',
    cursor: 'pointer',
  },
  collapseIcon: {
    backgroundImage: `url("${iconCollapse}")`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: '16px',
    height: '16px',
    width: '16px',
  },
  messagesContainer: {
    padding: '5px 16px 25px',
  },
  mobileScrollContainer: {
    flex: '1 1 auto',
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: chatHistoryBGColor,
    overflowY: 'scroll',
    justifyContent: 'flex-end',
    position: 'relative',
  },
  mobileMessageContainer: {
    padding: '5px 16px 25px',
    minHeight: 0,
    width: '100%',
  },
  mobileInputContainer: {
    marginTop: '20px',
  },
  wrapperDisabled: {
    padding: '10px',
    background: `${chatHistoryBGColor}`,
    boxShadow: `0 -8px 15px 0 ${chatInputDropShadow}`,
    textAlign: 'center',
  },
  disabledText: {
    color: grayText,
    fontWeight: '500',
    fontSize: '13px',
  },
};

export const afterHoursStyles = offhoursImageUrl => {
  return {
    flex: '1 1 auto',
    overflowY: 'auto',
    overflowX: 'hidden',
    backgroundPosition: 'center 33.333%',
    backgroundImage: `url("${offhoursImageUrl || awayImage}")`,
    backgroundRepeat: 'no-repeat',
  };
};

export default styles;
